import { Component, Input } from '@angular/core';
import {
  DASHBOARD_BANNER_ASSETS,
  DASHBOARD_EVENT_BANNER,
  DashboardEventBanner,
} from './dashboard-banner.config';

@Component({
  selector: 'app-welcome-banner',
  templateUrl: './welcome-banner.component.html',
  styleUrls: ['./welcome-banner.component.scss'],
})
export class WelcomeBannerComponent {
  @Input() fullName = '';
  @Input() loginName = '';
  @Input() lastLoginTime = '';

  readonly welcomeBannerImage = DASHBOARD_BANNER_ASSETS.welcomeImage;
  readonly eventBannerImage = DASHBOARD_BANNER_ASSETS.eventImage;
  readonly eventBanner: DashboardEventBanner = DASHBOARD_EVENT_BANNER;

  get displayName(): string {
    return this.fullName?.trim() || this.loginName?.trim() || 'bạn';
  }

  get welcomeSubtitle(): string {
    return 'Chào mừng bạn đến cổng ứng dụng SSO - Trường Đại học Thương mại';
  }

  get lastLoginDisplay(): string {
    return this.lastLoginTime?.trim() || 'Lần đầu đăng nhập';
  }
}
